export default "__VITE_ASSET__Bb9v$P4x__"